/**
 * R221: WotLK 3.3.5a-WoW style cursor icons. SVG data-URIs которые можно
 * подставить в `el.style.cursor`. 32×32px, hotspot в центре.
 */

function svgCursor(svg: string, hotX = 16, hotY = 16): string {
  const enc = svg
    .replace(/\s+/g, ' ')
    .replace(/#/g, '%23')
    .replace(/"/g, "'");
  return `url("data:image/svg+xml;utf8,${enc}") ${hotX} ${hotY}, auto`;
}

// Базовый круглый щит-фон, на котором лежит icon.
function bg(fill: string): string {
  return `<circle cx='16' cy='16' r='15' fill='${fill}' stroke='#000' stroke-width='1.5'/>`;
}

const ATTACK_SWORD = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(180,30,30,0.85)')}
  <path d='M9 22 L20 11 M22 9 L25 12 L23 14 Z M9 22 L7 24 L10 25 L11 22 Z'
        stroke='#FFE082' stroke-width='2' stroke-linecap='round' fill='#FFD54F'/>
</svg>`;

const LOOT_BAG = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(140,90,30,0.90)')}
  <path d='M10 12 L22 12 L24 26 L8 26 Z' fill='#A0522D' stroke='#000' stroke-width='1.2'/>
  <path d='M12 12 Q16 7 20 12' fill='none' stroke='#5C2C0E' stroke-width='2'/>
  <circle cx='16' cy='19' r='2.5' fill='#FFD54F' stroke='#8C4D14' stroke-width='1'/>
</svg>`;

const SKIN_KNIFE = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(150,80,40,0.90)')}
  <path d='M9 22 L18 13 L22 17 L13 26 Z' fill='#C49A6C' stroke='#5C3010' stroke-width='1'/>
  <path d='M18 13 L23 8 L27 12 L22 17 Z' fill='#E0E0E0' stroke='#000' stroke-width='1'/>
</svg>`;

const HERB_LEAF = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(40,140,60,0.90)')}
  <path d='M16 6 Q24 12 22 22 Q16 26 10 22 Q8 12 16 6 Z' fill='#7CFC50' stroke='#205020' stroke-width='1.2'/>
  <path d='M16 8 L16 24' stroke='#205020' stroke-width='1'/>
</svg>`;

const MINING_PICK = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(120,120,140,0.90)')}
  <path d='M7 23 L23 7' stroke='#8C5A2C' stroke-width='3' stroke-linecap='round'/>
  <path d='M5 13 Q9 9 17 13 L13 17 Q9 13 5 13 Z' fill='#C0C0C0' stroke='#000' stroke-width='1'/>
</svg>`;

const FISHING_ROD = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(40,90,180,0.90)')}
  <path d='M8 24 L26 6' stroke='#8C5A2C' stroke-width='2' stroke-linecap='round'/>
  <path d='M26 6 L24 18' stroke='#FAFAFA' stroke-width='1'/>
  <circle cx='24' cy='19' r='2' fill='#FFD54F' stroke='#000' stroke-width='1'/>
</svg>`;

const TALK_SCROLL = `
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
  ${bg('rgba(220,180,80,0.90)')}
  <path d='M9 8 H23 V24 H9 Z' fill='#FFF8E1' stroke='#5C3C0A' stroke-width='1.2'/>
  <path d='M12 13 H20 M12 16 H20 M12 19 H17' stroke='#5C3C0A' stroke-width='1' stroke-linecap='round'/>
  <text x='16' y='22' font-size='10' fill='#B8860B' text-anchor='middle' font-weight='bold'>!</text>
</svg>`;

export const CURSOR = {
  attack:  svgCursor(ATTACK_SWORD),
  loot:    svgCursor(LOOT_BAG),
  skin:    svgCursor(SKIN_KNIFE),
  herb:    svgCursor(HERB_LEAF),
  mining:  svgCursor(MINING_PICK),
  fishing: svgCursor(FISHING_ROD),
  talk:    svgCursor(TALK_SCROLL),
};
